/* Le Bon Collagène — invitation au questionnaire, une fois par onglet. */
(() => {
  'use strict';

  if (window.LBCProductFinderPopupLoaded) return;
  window.LBCProductFinderPopupLoaded = true;

  const SESSION_KEY = 'lbc_product_finder_popup_session_v1';
  const QUIZ_PATH = '/pages/trouver-mon-collagene';
  const ROOT_SELECTOR = '[data-lbc-finder-popup]';

  let disposeCurrent = () => {};

  const path = () =>
    window.location.pathname.replace(/\/+$/, '') || '/';

  function isSuppressed() {
    try {
      return sessionStorage.getItem(SESSION_KEY) !== null;
    } catch (_) {
      // Si la mémorisation est bloquée, éviter les sollicitations répétées.
      return true;
    }
  }

  function remember(reason) {
    try {
      sessionStorage.setItem(SESSION_KEY, reason);
      return true;
    } catch (_) {
      return false;
    }
  }

  function initialize() {
    disposeCurrent();
    disposeCurrent = () => {};

    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const editor =
      root.dataset.designMode === 'true' ||
      !!window.Shopify?.designMode;

    if (path() === QUIZ_PATH) {
      if (!editor) remember('questionnaire');
      return;
    }

    if (root.dataset.enabled !== 'true') return;

    const entries = Array.from(
      root.querySelectorAll('template[data-popup-path]')
    );

    const entry = entries.find(
      item => item.dataset.popupPath === path()
    );

    // L’aperçu sur une page non ciblée emploie le texte « Choisir ».
    const content =
      entry ||
      (
        editor &&
        entries.find(
          item => item.dataset.popupKey === 'choisir'
        )
      );

    const dialog = root.querySelector('dialog');

    if (
      !content ||
      !dialog ||
      typeof dialog.showModal !== 'function'
    ) {
      return;
    }

    if (!editor && isSuppressed()) return;

    dialog.querySelector('[data-popup-title]').textContent =
      content.dataset.popupTitle;

    dialog.querySelector('[data-popup-text]').textContent =
      content.dataset.popupText;

    dialog.querySelector('[data-popup-cta]').textContent =
      content.dataset.popupButton;

    dialog.querySelector('[data-popup-cta]').setAttribute(
      'href',
      QUIZ_PATH
    );

    const events = new AbortController();

    const listen = (target, type, callback) =>
      target.addEventListener(type, callback, {
        signal: events.signal
      });

    let timer = null;
    let startedAt = null;

    const configuredDelay = Number(root.dataset.delay);

    let remaining =
      (
        Number.isFinite(configuredDelay)
          ? Math.max(1, configuredDelay)
          : 25
      ) * 1000;

    let shown = false;
    let destroyed = false;
    let previousFocus = null;

    function pause() {
      if (timer !== null) clearTimeout(timer);
      timer = null;

      if (startedAt !== null) {
        remaining = Math.max(
          0,
          remaining - (performance.now() - startedAt)
        );
      }

      startedAt = null;
    }

    function restorePage() {
      document.documentElement.classList.remove(
        'lbc-finder-popup-open'
      );

      if (
        previousFocus instanceof HTMLElement &&
        previousFocus.isConnected
      ) {
        previousFocus.focus({
          preventScroll: true
        });
      }

      previousFocus = null;
    }

    function close() {
      if (dialog.open) dialog.close();
      restorePage();
    }

    function anotherInteraction() {
      const active = document.activeElement;

      if (
        active instanceof HTMLElement &&
        (
          active.matches('input, textarea, select') ||
          active.isContentEditable
        )
      ) {
        return true;
      }

      return Array.from(
        document.querySelectorAll(
          'dialog[open], [aria-modal="true"]'
        )
      ).some(element => {
        if (element === dialog) return false;

        const style = getComputedStyle(element);

        return (
          element.getClientRects().length > 0 &&
          style.visibility !== 'hidden' &&
          style.display !== 'none'
        );
      });
    }

    function open(preview = false) {
      if (
        destroyed ||
        dialog.open ||
        document.hidden ||
        path() === QUIZ_PATH
      ) {
        return;
      }

      if (!preview && (shown || isSuppressed())) return;

      previousFocus = document.activeElement;

      try {
        dialog.showModal();
      } catch (_) {
        return;
      }

      if (!preview) {
        shown = true;

        // Mémorisation dès l’affichage, sans attendre
        // une fermeture ou un clic.
        if (!remember('shown')) {
          close();
          return;
        }
      }

      document.documentElement.classList.add(
        'lbc-finder-popup-open'
      );

      dialog.querySelector('[data-popup-close]').focus({
        preventScroll: true
      });
    }

    function schedule() {
      if (
        destroyed ||
        editor ||
        shown ||
        document.hidden ||
        timer !== null ||
        isSuppressed()
      ) {
        return;
      }

      startedAt = performance.now();

      timer = setTimeout(
        tick,
        remaining > 0 ? remaining : 1000
      );
    }

    function tick() {
      pause();

      if (
        destroyed ||
        shown ||
        document.hidden ||
        isSuppressed()
      ) {
        return;
      }

      if (remaining > 1 || anotherInteraction()) {
        schedule();
        return;
      }

      open();
    }

    root.querySelectorAll('[data-popup-close]').forEach(
      button => listen(button, 'click', close)
    );

    listen(dialog, 'close', restorePage);

    // Échap est géré nativement par <dialog>.
    let pointerStartedOutside = false;

    function outside(event) {
      const rect = dialog.getBoundingClientRect();

      return (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      );
    }

    listen(dialog, 'pointerdown', event => {
      pointerStartedOutside =
        event.target === dialog && outside(event);
    });

    listen(dialog, 'click', event => {
      if (
        pointerStartedOutside &&
        event.target === dialog &&
        outside(event)
      ) {
        close();
      }

      pointerStartedOutside = false;
    });

    listen(document, 'visibilitychange', () => {
      if (document.hidden) {
        pause();
      } else {
        schedule();
      }
    });

    listen(window, 'pagehide', () => {
      pause();
      close();
    });

    listen(window, 'pageshow', () => {
      if (!editor && path() === QUIZ_PATH) {
        remember('questionnaire');
      }

      schedule();
    });

    const previewButton = root.querySelector(
      '[data-popup-preview]'
    );

    if (editor && previewButton) {
      listen(previewButton, 'click', () => open(true));
    }

    disposeCurrent = () => {
      destroyed = true;
      pause();
      close();
      events.abort();
    };

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }

  document.addEventListener(
    'shopify:section:load',
    event => {
      if (event.target.querySelector(ROOT_SELECTOR)) {
        initialize();
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {
      if (event.target.querySelector(ROOT_SELECTOR)) {
        disposeCurrent();
      }
    }
  );
})();